import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import TermsPopup from "../Popup/TermsPopup";
import Language from "../Card/Lang";
import $ from "jquery";
import { parseURLParams, produrl, textMapping } from "../utils/helper";
import ErrorPopup from "../Popup/ErrorPopup";
import Loader from "../Popup/Loader";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
// import Captcha from "./captcha";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
const CryptoJS = require("crypto-js");
const errorStyle = {
  color: "red",
  marginTop: "10px",
};
const EnterNumber = ({ staticnumber }) => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [mobileCheckError, setMobileCheckError] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [errorpopup, setErrorpopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");
  const [otptoken, setOtptoken] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [langSelect, setLangSelect] = useState("en");
  const [freshlang, setFreshlang] = useState("");
  const [errormsg, SetErrormsg] = useState("");
  const [captchaNum1, setCaptchaNum1] = useState(0);
  const [captchaNum2, setCaptchaNum2] = useState(0);
  const [ip, setIp] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaValue, setCaptchaValue] = useState(null);
  const navigate = useNavigate();
  const { refnum } = useParams();
  const recaptchaRef = useRef();

  // const { executeRecaptcha } = useGoogleReCaptcha();
  const handleCaptchaChange = (value) => {
    const token = value;
    setCaptchaValue(value);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      action: "tokenverify",
      token: token,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://campaign-api.narendramodi.in/sadasyata_moderation_2024",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        const parsedResult = JSON.parse(result);
        setLoading(false);
        if (parsedResult._resultflag === 1) {
          if (parsedResult.data.success) {
          } else {
            setErrorpopup(true);
            setMessage(
              textMapping("Captcha verification failed. Please try again.")
            );
            setIsButtonEnabled(false);
            recaptchaRef.current.reset();
          }
        } else {
          setErrorpopup(true);
          setMessage(textMapping("An error occurred. Please try again later."));
          setIsButtonEnabled(false);
          recaptchaRef.current.reset();
        }
      })
      .catch((error) => {
        console.error(error);
        setErrorpopup(true);
        setMessage(
          textMapping(
            "Network error. Please check your connection and try again."
          )
        );
        setIsButtonEnabled(false);
        recaptchaRef.current.reset();
      });
  };

  const decryptData = (encryptedData, secretKey) => {
    try {
      if (!encryptedData) return null;
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData ? JSON.parse(decryptedData) : null;
    } catch (error) {
      console.error("Error during decryption or parsing:", error);
      return null;
    }
  };

  useEffect(() => {
    fetchGoogleIP();
  }, []);

  const fetchGoogleIP = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      setIp(data.ip);
    } catch (error) {
      console.error("Error fetching IP:", error);
      setIp("Error fetching IP");
    }
  };

  useEffect(() => {
    const edit = localStorage.getItem("useredit");
    if (edit) {
      localStorage.removeItem("useredit");
    }
  }, [localStorage.getItem("useredit")]);

  useEffect(() => {
    const formattedNumber = staticnumber.startsWith("+91")
      ? staticnumber.replace(/^\+91\s*/, "")
      : staticnumber;

    if (formattedNumber) {
      setNumber(formattedNumber);
      setIsButtonEnabled(formattedNumber.length === 10);
      localStorage.setItem("num", formattedNumber);
    }
  }, [staticnumber]);

  useEffect(() => {
    const secretKey = "2ca6f23d8cc3e1e1";
    const encryptedData = localStorage.getItem("user");
    // setNumber(localStorage.getItem("number"));
    const decryptedData = decryptData(encryptedData, secretKey);

    if (decryptedData) {
      const numberval = decryptedData["number"] || "";
      const formattedNumber = numberval.startsWith("+91")
        ? numberval.replace(/^\+91\s*/, "")
        : numberval;
      setIsButtonEnabled(formattedNumber.length === 10);
    } else {
      if (localStorage.getItem("num")) {
        setIsButtonEnabled(localStorage.getItem("num").length === 10);
      }
      const localnum = localStorage.getItem("num");
      setNumber(localnum);
    }

    refreshCaptcha();
  }, []);

  const refreshCaptcha = () => {
    setCaptchaNum1(Math.floor(Math.random() * 10));
    setCaptchaNum2(Math.floor(Math.random() * 10));
    setCaptchaValue("");
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    // if (inputValue) {
    let regex = /^-?\d*\.?\d*$/;
    if (regex.test(inputValue)) {
      if (inputValue.length < 11) {
        setNumber(inputValue);

        setIsButtonEnabled(inputValue.length === 10);
        if (inputValue && inputValue?.length != 10) {
          setMobileCheckError(true);
        } else {
          setMobileCheckError(false);
        }
      }
    }
    // }

    // setNumber(inputValue);
    // setIsButtonEnabled(inputValue.length === 10);
    if (inputValue.length === 10) {
      localStorage.setItem("num", inputValue);
    }
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleClick = async (e) => {
    // setLoading(true);
    // const token = await executeRecaptcha("getotp");
    // console.log("token", token);
    // setCaptchaToken(token);
    // const myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");

    // const raw = JSON.stringify({
    //   action: "tokenverify",
    //   token: token,
    // });

    // const requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   body: raw,
    //   redirect: "follow",
    // };
    if (isChecked) {
      setIsClicked(true);
      setShowPopup(false);
      handleotp();
    } else {
      setShowPopup(true);
    }

    // fetch(
    //   "https://campaign-api.narendramodi.in/sadasyata_moderation_2024",
    //   requestOptions
    // )
    //   .then((response) => response.text())
    //   .then((result) => {
    //     const parsedResult = JSON.parse(result);
    //     setLoading(false);
    //     if (parsedResult._resultflag === 1) {
    //       if (parsedResult.data.success) {
    //         console.log("parsedResult", parsedResult);
    //         if (isChecked) {
    //           setIsClicked(true);
    //           setShowPopup(false);
    //           handleotp();
    //         } else if (!isChecked) {
    //           setShowPopup(true);
    //         } else {
    //           setErrorpopup(true);
    //           setMessage(textMapping("Incorrect captcha. Please try again."));
    //         }
    //       } else {
    //         setErrorpopup(true);
    //         setMessage(
    //           textMapping("Captcha verification failed. Please try again.")
    //         );
    //       }
    //     } else {
    //       setErrorpopup(true);
    //       setMessage(textMapping("An error occurred. Please try again later."));
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     setErrorpopup(true);
    //     setMessage(
    //       textMapping(
    //         "Network error. Please check your connection and try again."
    //       )
    //     );
    //   });
    return;

    //   } else {
    //     console.error("reCAPTCHA verification failed");
    //     // Handle the verification failure
    //   }
    // })
    // .catch((error) => {
    //   console.error("Error verifying reCAPTCHA:", error);
    // });
    // }
    // e.preventDefault();
    // // if (isChecked && parseInt(captchaValue) === captchaNum1 + captchaNum2) {
    // if (isChecked) {
    //   setIsClicked(true);
    //   setShowPopup(false);
    //   handleotp();
    // } else if (!isChecked) {
    //   setShowPopup(true);
    // } else {
    //   setErrorpopup(true);
    //   setMessage(textMapping("Incorrect captcha. Please try again."));
    // }
  };

  // useEffect(() => {
  //   setIsButtonEnabled(captchaValue !== null);
  // }, [captchaValue]);

  const handleotp = async () => {
    setLoading(true);
    const url = `${produrl}api/v1/otp/send`;
    const form = new FormData();
    let headers = [
      ["Content-Type", "application/json"],
      [
        "Akamai-BM-Telemetry",
        window.bmak && window.bmak.get_telemetry
          ? window.bmak.get_telemetry()
          : "",
      ],
    ];

    if (window.location.href.indexOf("appversion") != -1) {
      headers.push([
        "Custom-Header",
        "8a8a4871be43ad546a88af7f769cf672b665a13e46d90bf20f29916f92a617",
      ]);
    }

    const options = {
      method: "POST",
      headers: new Headers(headers),
      body: JSON.stringify({ phone_number: number }),
    };
    //error handling akamai
    const controller = new AbortController();
    const { signal } = controller;
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    //error handling akamai
    try {
      const response = await fetch(url, { ...options, signal });
      const customHeaderValue = response.headers.get("content-type");

      if (response.ok) {
        const data = await response.json();
        if (data) {
          try {
            let obj = {};
            window.gtag("event", `Login Successfully`, obj);
          } catch (error) {}
          setOtptoken(data.otp_token);
          localStorage.setItem("userotpkonen", data.otp_token);

          if (refnum) {
            navigate("/otp/" + refnum + window.location.search, {
              state: {
                userotp: data.otp_token ? data.otp_token : otptoken,
              },
            });
          } else {
            navigate("/otp" + window.location.search, {
              state: {
                userotp: data.otp_token ? data.otp_token : otptoken,
              },
            });
          }
        }
      } else {
        //error handling akamai
        let errorText = await response.text();
        const decodedText = new DOMParser().parseFromString(
          errorText,
          "text/html"
        ).documentElement.textContent;
        const referenceMatch = decodedText.match(
          /#\d+\.[a-f0-9]+\.\d+\.[a-f0-9]+/i
        );
        ///Reference #(\d+\.\d+\.\d+\.\w+)/
        const referenceNumber = referenceMatch ? referenceMatch[0] : "";

        if (response.status == 502) {
          console.log("sendotp 502", response.status);
          setErrorpopup(true);
          setMessage("502: Server Error");
        } else if (
          response.status == 403 &&
          customHeaderValue?.includes("text/html")
        ) {
          console.log("sendotp akamai 403", response.status);
          setErrorpopup(true);
          setMessage(
            textMapping(
              "Suspicious activity detected!! Access Denied " + referenceNumber
            )
          );
        } else if (response.status == 403) {
          let errorjson = JSON.parse(errorText);
          console.log("sendotp 403", response.status);
          setErrorpopup(true);
          setMessage(textMapping(errorjson.message));
        } else if (response.status == 400) {
          let errorjson = JSON.parse(errorText);
          console.log("sendotp 400", response.status);
          setErrorpopup(true);
          setMessage(textMapping(errorjson.message));
        } else {
          console.log("sendotp error", response.status);
          setErrorpopup(true);
          setMessage(textMapping("Error Occur"));
        }
        //error handling akamai
      }
    } catch (error) {
      console.error(error);
    } finally {
      clearTimeout(timeoutId);
      setLoading(false);
    }
  };

  const handleotp_old = async () => {
    setLoading(true);
    const url = `${produrl}api/v1/otp/send`;
    console.log("url", url);
    const form = new FormData();
    let headers = [
      ["Content-Type", "application/json"],
      [
        "Akamai-BM-Telemetry",
        window.bmak && window.bmak.get_telemetry
          ? window.bmak.get_telemetry()
          : "",
      ],
    ];

    if (window.location.href.indexOf("appversion") != -1) {
      headers.push([
        "Custom-Header",
        "8a8a4871be43ad546a88af7f769cf672b665a13e46d90bf20f29916f92a617",
      ]);
    }
    console.log("headers", headers);
    const options = {
      method: "POST",
      headers: new Headers(headers),
      body: JSON.stringify({ phone_number: number }),
    };
    console.log("options", options);
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      console.log("res", response.status);
      if (response.status == 200) {
        if (data) {
          try {
            let obj = {};
            window.gtag("event", `Login Successfully`, obj);
          } catch (error) {}
          setOtptoken(data.otp_token);
          localStorage.setItem("userotpkonen", data.otp_token);

          if (refnum) {
            navigate("/otp/" + refnum + window.location.search, {
              state: {
                userotp: data.otp_token ? data.otp_token : otptoken,
                // remaingotp: data.remaining_otp_attempts
                //   ? data.remaining_otp_attempts
                //   : "",
              },
            });
          } else {
            navigate("/otp" + window.location.search, {
              state: {
                userotp: data.otp_token ? data.otp_token : otptoken,
                // remaingotp: data.remaining_otp_attempts
                //   ? data.remaining_otp_attempts
                //   : "",
              },
            });
          }
        }
      } else if (response.status == 502) {
        setErrorpopup(true);
        setMessage("502: Server Error");
      } else if (response.status == 403) {
        setErrorpopup(true);
        // setMessage(data.message);
        setMessage(textMapping(data.message));
      } else {
        setErrorpopup(true);
        // setMessage(data.message);
        setMessage(textMapping(data.message));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const popupclose = () => {
    setErrorpopup(false);
  };

  const termclose = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (localStorage.getItem("language")) {
      setLangSelect(localStorage.getItem("language"));
    } else {
      localStorage.setItem("language", langSelect);
    }
  }, [langSelect]);

  const setLanguval = (lang) => {
    setFreshlang(lang);
  };
  return (
    <>
      {loading && <Loader />}

      <section className="main_bg">
        <div className="lang_main_flex lang_main_flex_pad">
          <div className="lang_headerbg">
            <div className="member_container">
              <div className="lang_header">
                <div className="janta_part_flex">
                  <img
                    src="/assets/images/bjplogonew.png"
                    className="bjplogo"
                    alt="BJPL Logo"
                  />
                  <h6>{textMapping("Bharatiya Janata Party")}</h6>
                </div>
                <Language freshlang={setLanguval} />
              </div>
            </div>
          </div>
          <div className="member_container">
            <div className="post_up">
              <img
                src="/assets/images/banner.jpg"
                className="bjpsadyata"
                alt="Sadyasta Logo"
              />

              <h3 className="bjpabhiyan">
                {textMapping("भाजपा सदस्यता अभियान - 2024")}
              </h3>
              <div className="select_lang">
                <h5>{textMapping("Enter your mobile number")}</h5>
                <div className="enter_number">
                  <h4>+91</h4>
                  <input
                    type="tel"
                    className="number_input"
                    value={number}
                    onChange={handleInputChange}
                  />
                </div>
                {/* <div style={{ marginTop: "12px" }}>
                  <ReCAPTCHA
                    sitekey="6LexxUkqAAAAAARLaSJiSf-SLquPzo3FXIJrsC4Q"
                    // sitekey="6LdnMjkqAAAAAGBg1vriaXMe-3l_9V786xNs21u7"
                    // onChange={(value) => setCaptchaValue(value)}
                    onChange={handleCaptchaChange}
                    ref={recaptchaRef}
                  />
                </div> */}

                {/* <div className="captcha-container" style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: '15px',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '5px'
                }}>
                  <div className="captcha-image" style={{
                    fontSize: '18px',
                    fontWeight: 'bold'
                  }}>
                    <span>{captchaNum1} + {captchaNum2} = ?</span>
                  </div>
                  <div className="captcha-input" style={{
                    flex: 1,
                    marginLeft: '10px',
                    marginRight: '10px'
                  }}>
                    <input
                      type="tel"
                      placeholder="Enter sum"
                      value={captchaValue}
                      onChange={(e) => setCaptchaValue(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '5px',
                        border: '1px solid #ccc',
                        borderRadius: '3px'
                      }}
                    />
                  </div>
                </div> */}
                {mobileCheckError && (
                  <p style={errorStyle}>
                    {textMapping("Please enter a 10-digit mobile number.")}
                  </p>
                )}
              </div>
              <label className="container_check">
                <input
                  type="checkbox"
                  // checked="checked"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                {textMapping(
                  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details"
                )}

                <span style={errorStyle} className="checkmark"></span>
              </label>
            </div>
          </div>

          <div className="member_container">
            <a
              // href="/otp"
              className={`next_pagebtn ${
                isButtonEnabled ? "" : "next_pagebtn_disable"
              } ${isClicked ? "addanimation" : ""} `}
              // ${
              //   captchaValue ? "" : "next_pagebtn_disable"
              // }
              // onClick={handleotp}
              onClick={handleClick}
            >
              <span>{textMapping("Get Verification Code")}</span>
              <img
                src="/assets/images/arrownext.svg"
                className="active_arrow"
                alt="Arrow Next"
              />
              <img
                src="/assets/images/chevrondisable.svg"
                className="disable_arrow"
                alt="Chevron Disable"
              />
            </a>
          </div>
        </div>
        {showPopup && <TermsPopup popupclose={termclose} />}
        {errorpopup && <ErrorPopup message={message} popupclose={popupclose} />}
      </section>
    </>
  );
};

export default EnterNumber;
